module.exports = __webpack_public_path__ + "static-portal/img/new8-6.cc1237e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-6.png
// module id = MLD/
// module chunks = 4